import { useState } from "react";
import { Input } from "@/components/ui/input";

// Campo nome con menù a tendina dei materiali in magazzino mentre scrivi
export const MaterialPicker = ({ items = [], value, onChange, onPick, kind, placeholder, testid }) => {
  const [open, setOpen] = useState(false);
  const sub = (m) => (kind === "tessuto" ? [m.fabric_type, m.supplier, m.season] : [m.type, m.unit, m.supplier]).filter(Boolean).join(" · ");
  const q = (value || "").trim().toLowerCase();
  const list = items.filter((m) => !q || `${m.name} ${sub(m)}`.toLowerCase().includes(q)).slice(0, 30);
  return (
    <div className="relative">
      <Input value={value} placeholder={placeholder} autoComplete="off" data-testid={testid}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && list.length > 0 && (
        <div className="absolute left-0 right-0 top-full z-50 mt-1 max-h-64 overflow-y-auto rounded-md border border-border bg-popover shadow-lg" data-testid={`${testid}-menu`}>
          {list.map((m, i) => (
            <button key={m.name} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onPick(m); setOpen(false); }}
              className="block w-full px-3 py-1.5 text-left transition-colors hover:bg-secondary" data-testid={`${testid}-item-${i}`}>
              <span className="block text-sm">{m.name}</span>
              {sub(m) && <span className="block text-[11px] text-muted-foreground">{sub(m)}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
